var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-select',{staticClass:"dash-text__16 dash-text__400 main-lang-select",attrs:{"value":_vm.currentLang,"dropdownClassName":"main-lang-select__dropdown"},on:{"select":_vm.changeLang}},_vm._l((_vm.langs),function(lang){return _c('a-select-option',{key:lang.id,attrs:{"value":lang.id}},[_vm._v(" "+_vm._s(lang.id.toUpperCase())+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }